import React from "react";
import ReactDOM from "react-dom";
import { WelcomeBanner } from "./components/banner/WelcomeBanner";
import { storageFactory } from "./utils/storageFactory";

(async () => {
    const response: any = await fetch("/api/patient/configuration-editor/");
    if (response.ok) {
        const data: any = await response.json();
        const welcomeBanner = data?.welcomeBanner;
        const WELCOME_BANNER_KEY = `welcome banner key: ${data?.provider} : ${data?.pbu}`;
        const sessionStore = storageFactory(() => sessionStorage);
        const showBanner = sessionStore.getItem(WELCOME_BANNER_KEY) !== "true";
        const otherBannerIsDisplayed = $("._banner_above_nav:visible").length > 0;

        if (welcomeBanner?.body && showBanner && !otherBannerIsDisplayed) {
            if ($(".welcome-banner").length === 0) {
                $('<div class="welcome-banner"/>').prependTo($("header > .fixed"));
            }
            const container = $("header > .fixed .welcome-banner").get(0) as HTMLElement;
            ReactDOM.render(
                <WelcomeBanner
                    title={welcomeBanner?.title}
                    content={welcomeBanner.body}
                    bannerStyle={welcomeBanner.style}
                    onClose={() => {
                        sessionStore.setItem(WELCOME_BANNER_KEY, "true");
                        $(".invisible .welcome-banner").remove();
                    }}
                />,
                container,
            );
            //need to clone welcome banner to invisible to position main content properly
            $(".welcome-banner").clone().prependTo($("body > .invisible"));
        }
    }
})();
